import { render } from "./ManagerMenu.vue?vue&type=template&id=c979344e"
import script from "./ManagerMenu.vue?vue&type=script&lang=js"
export * from "./ManagerMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__